import { NodeType } from './types';

const SIMPLE_VALUES = [NodeType.boolean, NodeType.string, NodeType.number, NodeType.null];

export const isSimpleValue = (value: NodeType): boolean => {
  return SIMPLE_VALUES.includes(value);
};
